import { Box, Flex, Tooltip, useMantineTheme } from '@mantine/core';
import { OrganizationRow } from 'components/tables/data/organization/types';
import BadgeDeleted from 'components/Badge';
import P2Medium from 'components/typography/P2Medium';
import { IconChartPieOff, IconKeyOff } from '@tabler/icons-react';
import Slider from 'components/modals/slider/Slider';
import { useDisclosure } from '@mantine/hooks';
import FileThumbnail from 'components/files/FileThumbnail';

/**
 * Logo of the organization.
 */
function OrganizationLogo({ logoFileId }: { logoFileId?: string }) {
  const [sliderOpened, { open: openSlider, close: closeSlider }] = useDisclosure(false);

  if (!logoFileId) {
    return <Box w={44} h={44} miw={44} mih={44} mah={44} maw={44} />;
  }

  return (
    <>
      <FileThumbnail fileId={logoFileId} onOpenSlider={openSlider} />
      <Slider opened={sliderOpened} fileIds={[logoFileId]} onClose={closeSlider} initialImageId={logoFileId} />
    </>
  );
}

/**
 * Column for the organization name.
 */
export default function OrganizationNameColumn({
  data: { organizationName, status, inKepHashArchive, includedInStatistics, logoFileId },
}: {
  data: OrganizationRow;
}) {
  const theme = useMantineTheme();
  const rowOpacity = status ? 1 : 0.6;

  return (
    <Flex gap={8} align="center">
      {!status && <BadgeDeleted text="Vyradená" />}
      <OrganizationLogo logoFileId={logoFileId} />
      <P2Medium color="gray.8" style={{ opacity: rowOpacity }}>
        {organizationName}
      </P2Medium>
      {!includedInStatistics && (
        <Tooltip label="Organizácia je vyňatá zo štatistík" disabled={!status}>
          <IconChartPieOff size={20} color={theme.colors.red[8]} style={{ opacity: rowOpacity }} />
        </Tooltip>
      )}
      {!inKepHashArchive && (
        <Tooltip label="KEP hash archív je vypnutý" disabled={!status}>
          <IconKeyOff size={20} color={theme.colors.red[8]} style={{ opacity: rowOpacity }} />
        </Tooltip>
      )}
    </Flex>
  );
}
